class AgrotropicHeaderMenuOverlay {
  constructor() {
    document.addEventListener('mousedown', this.onMouseDown.bind(this), true);
    document.addEventListener('click', this.onClick.bind(this), true);
    document.addEventListener('toggle', this.onToggle.bind(this), true);
  }

  onMouseDown(event) {
    const trigger = event.target.closest('[data-agrotropic-menu-overlay-trigger]');
    if (trigger) {
      event.preventDefault();
    }
  }

  onClick(event) {
    const trigger = event.target.closest('[data-agrotropic-menu-overlay-trigger]');
    if (trigger) {
      event.preventDefault();
      event.stopPropagation();
      this.toggleOverlay(trigger);
      return;
    }

    const closeButton = event.target.closest('[data-agrotropic-menu-overlay-close]');
    if (closeButton) {
      event.preventDefault();
      event.stopPropagation();
      const panel = closeButton.closest('[data-agrotropic-menu-panel]');
      const overlay = closeButton.closest('[data-agrotropic-menu-overlay]');
      this.closePanel(panel, { overlay });
      return;
    }
  }

  onToggle(event) {
    const details = event.target;
    if (details.tagName !== 'DETAILS') return;

    const panel = details.querySelector('[data-agrotropic-menu-panel]');
    if (!details.open && panel) {
      this.closePanel(panel, { restoreFocus: false });
    }
  }

  toggleOverlay(trigger) {
    const panel = trigger.closest('[data-agrotropic-menu-panel]');
    if (!panel) return;

    const handle = trigger.getAttribute('data-agrotropic-menu-overlay-trigger');
    const overlay = panel.querySelector(`[data-agrotropic-menu-overlay="${handle}"]`);
    if (!overlay) return;

    if (overlay.classList.contains('is-active')) {
      this.closePanel(panel, { overlay });
      return;
    }

    this.openOverlay(panel, overlay, trigger);
  }

  openOverlay(panel, overlay, trigger) {
    this.closePanel(panel, { restoreFocus: false });

    panel.focus({ preventScroll: true });
    overlay.classList.add('is-active');
    panel.classList.add('agrotropic-header-menu-panel--overlay-open');
    trigger.setAttribute('aria-expanded', 'true');
    trigger.classList.add('is-active');
    panel._agrotropicOverlayTrigger = trigger;

    const backButton = overlay.querySelector('[data-agrotropic-menu-overlay-close]');
    if (backButton) {
      backButton.focus({ preventScroll: true });
    }
  }

  closePanel(panel, { overlay = null, restoreFocus = true } = {}) {
    if (!panel) return;

    if (restoreFocus) {
      panel.focus({ preventScroll: true });
    }

    panel.classList.remove('agrotropic-header-menu-panel--overlay-open');

    if (overlay) {
      overlay.classList.remove('is-active');
    } else {
      panel.querySelectorAll('[data-agrotropic-menu-overlay].is-active').forEach((activeOverlay) => {
        activeOverlay.classList.remove('is-active');
      });
    }

    panel._agrotropicOverlayTrigger = null;

    panel.querySelectorAll('[data-agrotropic-menu-overlay-trigger]').forEach((trigger) => {
      trigger.setAttribute('aria-expanded', 'false');
      trigger.classList.remove('is-active');
    });
  }
}

new AgrotropicHeaderMenuOverlay();
